import { useDataChange, useDataValue } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let cities = useDataValue({
    viewPath: props.viewPath,
    context: 'cities',
  })
  let selectedId = useDataValue({
    viewPath: props.viewPath,
    context: 'city',
    path: 'id',
  })
  let setCity = useDataChange({
    context: 'new_address',
    path: 'city',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let selected = cities.find(item => item.id === selectedId)
    setCity(selected.value)
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
